// ---------------------------------------------------------------------------
// Public demo builder mode (demo.usekestrel.ai)
//
// The platform frontend image is served unchanged at demo.usekestrel.ai; when
// the app detects the demo hostname it mounts only the Workflow Builder in a
// forced-simulated, unauthenticated configuration backed by the public
// /api/public/demo/* endpoints. A localStorage override exists for local
// development: localStorage.setItem('kestrelDemoMode', 'true').
// ---------------------------------------------------------------------------

export const DEMO_HOSTNAME = 'demo.usekestrel.ai';

// Exported for tests; app code should use the IS_DEMO_MODE constant.
export function detectDemoMode(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.location.hostname === DEMO_HOSTNAME) return true;
  try {
    return window.localStorage.getItem('kestrelDemoMode') === 'true';
  } catch {
    return false;
  }
}

export const IS_DEMO_MODE = detectDemoMode();

export const DEMO_SIGNUP_URL = 'https://platform.usekestrel.ai/register';
